import React, { useState, useRef } from 'react'
import * as styles from './ForgotPassword.css'
import { Redirect, Link } from 'react-router-dom'
import Flash from '../Flash'
import Logger from '../Logger'
import ALERT_TYPES from '../SharedConstants/AlertTypes'
import { BLUELEAF_LOGO_WHITE } from '../SharedConstants/Images'
import LoadingBar from 'react-top-loading-bar'
import { checkCognitoStatus } from '../ExternalHosts/mono'
require('dotenv').config()

export default function ForgotPasswordForm (props) {
  const { CognitoIdentityLib } = props
  const [email, setEmail] = useState('')
  const [alertType, setAlertType] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [redirect, setRedirect] = useState(false)
  const loadingRef = useRef(null)

  const handleSubmit = (e) => {
    Logger.start('Submit Forgot Password', { email: email })
    e.preventDefault()
    setAlertType('')
    loadingRef.current.continuousStart()
    const userPool = new CognitoIdentityLib.CognitoUserPool({
      UserPoolId: process.env.USER_POOL_ID,
      ClientId: process.env.COGNITO_APP_ID
    })

    const userData = {
      Username: email,
      Pool: userPool
    }

    const cognitoUser = new CognitoIdentityLib.CognitoUser(userData)
    const contactUsMessage = 'If your email address is registered in our system, you will receive an email from Blueleaf. Need help? Contact us <a href="mailto:vipsupport@blueleaf.com">here</a>.'

    checkCognitoStatus(email).then((response) => {
      if (response.status === 'UNCONFIRMED') {
        loadingRef.current.complete()
        Flash.setMessage(contactUsMessage)
        setRedirect(true)
        return
      }

      if (response.status === 'NOT_FOUND') {
        loadingRef.current.complete()
        Flash.setMessage(contactUsMessage)
        setRedirect(true)
        return
      }

      cognitoUser.forgotPassword({
        onSuccess: (result) => {
          loadingRef.current.complete()
          Logger.done('Submit Forgot Password', { email: email })
          Flash.setMessage(contactUsMessage)
          setRedirect(true)
        },
        onFailure: (err) => {
          loadingRef.current.complete()
          Logger.error('Submit Forgot Password', err)
          setAlertType(ALERT_TYPES.UPDATE_FAILED)
          setErrorMessage(err.message || JSON.stringify(err))
        }
      })
    })
  }

  const renderAlert = () => {
    if (alertType === ALERT_TYPES.UPDATE_FAILED) {
      const markup = { __html: errorMessage }
      return <div className={styles.alert} dangerouslySetInnerHTML={markup} />
    }
  }

  if (redirect) {
    return <Redirect id="login-redirect" to="/" />
  }

  return (
    <div className={styles.wrapper}>
      <LoadingBar color='#ffffff' ref={loadingRef} />
      <div className={styles.decorativeCircleTop}></div>
      <div className={styles.decorativeCircleBottom}></div>

      <div className={styles.mainContent}>
        <div className={styles.formWrapper}>
          <div className={styles.logoContainer}>
            <img
              alt="Blueleaf"
              src={BLUELEAF_LOGO_WHITE}
              className={styles.logo}
            />
          </div>

          <div className={styles.formCard}>
            { renderAlert() }

            <div className={styles.formHeader}>
              <h2 className={styles.title}>Forgot your password?</h2>
            </div>

            <form id="forgot-password-form" onSubmit={handleSubmit}>
              <div className={styles.formDescription}>
                If your email address is in our system and confirmed by you,
                you'll receive a link to reset your password. Should you still need to confirm your email address,
                we'll send you a confirmation link and then you'll be able to sign in
              </div>

              <div className={styles.fieldGroup}>
                <label className={styles.label}>
                  Your Email Address
                </label>
                <input
                  className={styles.input}
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                />
              </div>

              <input
                id="submit-btn"
                className={styles.submitButton}
                type="submit"
                value="Reset Password"
              />
              <Link
                id="sign-in-btn"
                className={styles.backToSignIn}
                to="/"
              >
                Back to sign in
              </Link>
            </form>
          </div>

          <div className={styles.supportContainer}>
            <span className={styles.supportText}>
              Need help? <a href="mailto:vipsupport@blueleaf.com" className={styles.supportLink}>
                Contact support
              </a>
            </span>
          </div>
        </div>
      </div>

      <div className={styles.footer}>
        <p className={styles.footerText}>
          © 2010–2026 Blueleaf Wealth, Inc. All rights reserved. Patent pending.
        </p>
      </div>
    </div>
  )
}
